import React, { useEffect, useRef, useState } from "react";
import { axiosInstance } from "../../Api/config";

const fallbackCustomers = [
  {
    name: "Ravi Kumar",
    location: "Katpadi",
    bike: "Bullet 350",
    review:
      "Amazing service and a buttery-smooth buying experience. The team walked me through everything — I rode out the same day. Absolutely loved it!",
    stars: 5,
    initial: "R",
  },
  {
    name: "Suresh Babu",
    location: "Vellore",
    bike: "Hunter 350",
    review:
      "Very professional team. The test ride process was quick and zero-pressure. Best showroom experience I've had in years.",
    stars: 5,
    initial: "S",
  },
  {
    name: "Arun Prakash",
    location: "Ambur",
    bike: "Meteor 350",
    review:
      "Best showroom in Katpadi — hands down. Expert guidance, easy finance, and the staff treated me like family. Highly recommended!",
    stars: 5,
    initial: "A",
  },
];

const HappyCostomer = ({ onOpenModal }) => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axiosInstance.get("/testimonials/active");
        if (response.data && response.data.length > 0) {
          const apiCustomers = response.data.map(c => ({
            name: c.name,
            location: c.location,
            bike: c.bike,
            review: c.review,
            stars: parseInt(c.stars) || 5,
            initial: c.name ? c.name[0].toUpperCase() : "C"
          }));
          setCustomers(apiCustomers);
        } else {
          setCustomers(fallbackCustomers);
        }
      } catch (err) {
        console.error("Error fetching testimonials:", err);
        setCustomers(fallbackCustomers);
      }
    };
    fetchTestimonials();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <style>{`
        /* ── FONT CHANGE: Oswald (display) + DM Sans (body) ── */
        @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=DM+Sans:wght@400;500;600&family=Barlow+Condensed:wght@400;600;700;800&display=swap');

        .font-bebas       { font-family: 'Oswald', sans-serif; letter-spacing: 0.02em; }
        .font-barlow      { font-family: 'DM Sans', sans-serif; }
        .font-barlow-cond { font-family: 'Barlow Condensed', sans-serif; }

        .review-grid-bg {
          background-image:
            linear-gradient(rgba(212,175,55,0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(212,175,55,0.03) 1px, transparent 1px);
          background-size: 56px 56px;
        }

        .review-card {
          position: relative;
          background: #111111111;
          border: 1px solid rgba(255,255,255,0.05);
          overflow: hidden;
          transition: border-color 0.35s, transform 0.35s;
          clip-path: polygon(0 0, calc(100% - 20px) 0, 100% 20px, 100% 100%, 20px 100%, 0 calc(100% - 20px));
        }
        .review-card:hover {
          border-color: rgba(212,175,55,0.45);
          transform: translateY(-6px);
        }

        .review-card::before {
          content: '';
          position: absolute;
          top: 0; right: 0;
          width: 0; height: 0;
          border-style: solid;
          border-width: 0 36px 36px 0;
          border-color: transparent #D4AF37 transparent transparent;
          z-index: 2;
          transition: border-width 0.3s;
        }
        .review-card:hover::before {
          border-width: 0 44px 44px 0;
        }

        .review-card::after {
          content: '';
          position: absolute;
          bottom: -40px; left: 50%;
          transform: translateX(-50%);
          width: 180px; height: 80px;
          background: radial-gradient(circle, rgba(212,175,55,0.15) 0%, transparent 70%);
          opacity: 0;
          transition: opacity 0.4s;
          pointer-events: none;
        }
        .review-card:hover::after { opacity: 1; }

        .giant-quote {
          font-family: 'Oswald', sans-serif;
          font-size: 120px;
          line-height: 0.7;
          color: rgba(212,175,55,0.08);
          position: absolute;
          top: 16px; left: 16px;
          pointer-events: none;
          user-select: none;
          transition: color 0.35s;
        }
        .review-card:hover .giant-quote {
          color: rgba(212,175,55,0.14);
        }

        .avatar-hex {
          clip-path: polygon(50% 0%,100% 25%,100% 75%,50% 100%,0% 75%,0% 25%);
          background: #D4AF37;
          transition: box-shadow 0.35s;
        }
        .review-card:hover .avatar-hex {
          box-shadow: 0 0 20px rgba(212,175,55,0.5);
        }

        .star { color: #D4AF37; }

        .red-bar {
          background: linear-gradient(to right, #D4AF37, transparent);
        }

        .card-reveal {
          opacity: 0;
          transform: translateY(40px);
          transition: opacity 0.7s ease, transform 0.7s ease;
        }
        .card-reveal.shown {
          opacity: 1;
          transform: translateY(0);
        }

        .section-watermark {
          font-family: 'Oswald', sans-serif;
          font-size: clamp(60px, 12vw, 160px);
          color: rgba(212,175,55,0.04);
          letter-spacing: -3px;
          pointer-events: none;
          user-select: none;
          white-space: nowrap;
        }

        .ticker-track2 {
          display: flex; gap: 80px; white-space: nowrap;
          animation: tickerScroll2 20s linear infinite;
        }
        @keyframes tickerScroll2 {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }

        .rating-badge {
          clip-path: polygon(0 0, calc(100% - 8px) 0, 100% 50%, calc(100% - 8px) 100%, 0 100%);
        }

        .shimmer-line {
          background: linear-gradient(to right, transparent, rgba(212,175,55,0.4), transparent);
        }
      `}</style>

      <section ref={sectionRef} className="relative w-full bg-[#050505] py-24 overflow-hidden">
        <div className="review-grid-bg absolute inset-0 z-0 pointer-events-none" />
        <div className="section-watermark absolute top-6 right-0 z-0 select-none text-right pr-6">REVIEWS</div>
        <div className="absolute left-0 top-1/4 bottom-1/4 w-[3px] bg-gradient-to-b from-transparent via-[#D4AF37] to-transparent opacity-40" />

        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">

          {/* HEADER */}
          <div className={`card-reveal ${visible ? "shown" : ""} flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16`}>
            <div>
              <div className="flex items-center gap-3 font-barlow-cond text-[11px] tracking-[4px] uppercase text-[#D4AF37] mb-4">
                <span className="w-8 h-px bg-[#D4AF37]" />
                Testimonials
              </div>
              <h2 className="font-bebas leading-[0.9]" style={{ fontSize: "clamp(48px, 7vw, 90px)" }}>
                <span className="text-[#F5F5F5]">Happy </span>
                <span className="text-[#D4AF37]">Custo</span>
                <span className="font-bebas" style={{ WebkitTextStroke: "1.5px #F5F5F5", color: "transparent" }}>mers</span>
              </h2>
            </div>

            <div className={`card-reveal ${visible ? "shown" : ""} flex flex-col items-start md:items-end gap-3`} style={{ transitionDelay: "0.15s" }}>
              <div className="flex items-center gap-3">
                <div className="rating-badge bg-[#D4AF37] px-5 py-2 font-bebas text-[28px] text-white leading-none">
                  4.9★
                </div>
                <div className="flex flex-col">
                  <span className="font-barlow font-semibold text-[#F5F5F5] text-[14px]">Overall Rating</span>
                  <span className="font-barlow-cond text-[#666] text-[11px] tracking-[2px] uppercase">500+ Happy Riders</span>
                </div>
              </div>
              {/* Paragraph — 16px, brighter */}
              <p className="font-barlow text-[#9CA3AF] text-[16px] max-w-[280px] md:text-right leading-[1.8]">
                Real feedback from our satisfied riders across Tamil Nadu.
              </p>
            </div>
          </div>

          {/* CARDS */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {customers.map((user, index) => (
              <div
                key={index}
                className={`review-card card-reveal ${visible ? "shown" : ""}`}
                style={{ transitionDelay: `${0.1 + index * 0.13}s` }}
              >
                <div className="giant-quote">"</div>

                <div className="relative z-10 p-6 flex flex-col gap-4">
                  <div className="flex gap-1">
                    {[...Array(user.stars)].map((_, i) => (
                      <span key={i} className="star text-[14px]">★</span>
                    ))}
                  </div>

                  {/* Review text — 15px, #9CA3AF */}
                  <p className="font-barlow text-[#9CA3AF] text-[15px] leading-[1.85] pt-2">
                    {user.review}
                  </p>

                  <div className="shimmer-line h-px w-full" />

                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="avatar-hex w-10 h-10 flex items-center justify-center font-bebas text-[18px] text-white flex-shrink-0">
                        {user.initial}
                      </div>
                      <div className="flex flex-col">
                        <span className="font-bebas text-[18px] text-[#F5F5F5] leading-none tracking-wide">{user.name}</span>
                        {/* Location — brighter */}
                        <span className="font-barlow-cond text-[11px] tracking-[2px] uppercase text-[#666]">{user.location}</span>
                      </div>
                    </div>
                    <span className="font-barlow-cond text-[10px] tracking-[2px] uppercase text-[#D4AF37] bg-[#D4AF37]/10 border border-[#D4AF37]/20 px-3 py-1 whitespace-nowrap">
                      {user.bike}
                    </span>
                  </div>

                  <div className="red-bar h-[2px] w-full rounded-full mt-1" />
                </div>
              </div>
            ))}
          </div>

          {/* CTA STRIP */}
          <div
            className={`card-reveal ${visible ? "shown" : ""} mt-16 border border-[#D4AF37]/15 bg-[#111111] overflow-hidden`}
            style={{
              transitionDelay: "0.5s",
              clipPath: "polygon(0 0, calc(100% - 24px) 0, 100% 24px, 100% 100%, 24px 100%, 0 calc(100% - 24px))",
            }}
          >
            <div className="flex flex-col md:flex-row items-center justify-between gap-6 px-8 py-7">
              <div>
                <p className="font-barlow-cond text-[11px] tracking-[4px] uppercase text-[#D4AF37] mb-1">Join the Family</p>
                <p className="font-bebas text-[28px] md:text-[36px] text-[#F5F5F5] leading-none">
                  Be the next happy rider →
                </p>
              </div>
              <div className="flex gap-4 flex-shrink-0">
                <button
                onClick={ onOpenModal}
                  className="font-barlow-cond text-[12px] tracking-[3px] uppercase text-white bg-[#D4AF37] hover:bg-[#E5C158] px-7 py-3 transition-colors duration-300"
                  style={{ clipPath: "polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%)" }}
                >
                  Book Test Ride
                </button>
                <button className="font-barlow-cond text-[12px] tracking-[3px] uppercase text-[#9CA3AF] border border-[#D4AF37]/25 px-6 py-3 hover:border-[#D4AF37] hover:text-[#F5F5F5] transition-all duration-300">
                  Call Us
                </button>
              </div>
            </div>
          </div>

          {/* TICKER */}
          <div className="mt-16 border-t border-b border-[#FF6B00]/10 py-3 overflow-hidden -mx-6 md:-mx-12">
            <div className="ticker-track2">
              {[...Array(2)].flatMap(() =>
                ["Ravi Kumar", "Suresh Babu", "Arun Prakash", "Karthik R", "Praveen S", "Dinesh M", "Vijay T", "Santhosh K"].map((name, i) => (
                  <div key={`${name}-${i}`} className="flex items-center gap-5 flex-shrink-0">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#FF6B00]" />
                    <span className="font-barlow-cond text-[12px] tracking-[3px] uppercase text-[#444]">{name} · ⭐⭐⭐⭐⭐</span>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HappyCostomer;